import {
  CONNECTOR_TYPES,
  type ConnectorType,
} from '../../policyholders/connectors/connectors.constants';
import type { Nullable } from '../../types/common/utility';
import { ServiceHandler } from '../../utils';
import { ClaudeSchema } from './schemas/claude.schema';
import { CloudflareSchema } from './schemas/cloudflare.schema';
import { GeminiSchema } from './schemas/gemini.schema';
import { GoogleCloudSecurityCommandCenterSchema } from './schemas/googleCloudSecurityCommandCenter.schema';
import { GoogleWorkSpaceSchema } from './schemas/googleWorkspace.schema';
import { LangfuseSchema } from './schemas/langfuse.schema';
import { SophosSchema } from './schemas/sophos.schema';

const schemaMapping = {
  [CONNECTOR_TYPES.AWS]: {},
  [CONNECTOR_TYPES.CLAUDE]: ClaudeSchema,
  [CONNECTOR_TYPES.CLOUDFLARE]: CloudflareSchema,
  [CONNECTOR_TYPES.GEMINI]: GeminiSchema,
  [CONNECTOR_TYPES.GOOGLEWORKSPACE]: GoogleWorkSpaceSchema,
  [CONNECTOR_TYPES.GSC]: GoogleCloudSecurityCommandCenterSchema,
  [CONNECTOR_TYPES.LANGFUSE]: LangfuseSchema,
  [CONNECTOR_TYPES.MICROSOFT]: {},
  [CONNECTOR_TYPES.QUALYSCS]: {},
  [CONNECTOR_TYPES.QUALYSPC]: {},
  [CONNECTOR_TYPES.QUALYSVM]: {},
  [CONNECTOR_TYPES.SAFEGUARD]: {},
  [CONNECTOR_TYPES.SECUREWORKS]: {},
  [CONNECTOR_TYPES.SECURITYSTUDIO]: {},
  [CONNECTOR_TYPES.SOPHOS]: SophosSchema,
  [CONNECTOR_TYPES.WIZER]: {},
  [CONNECTOR_TYPES.COWBELL_MDR]: {},
};

export const getConnectorSchema = (connectorType: Nullable<ConnectorType>) => {
  if (connectorType) {
    return Promise.resolve(schemaMapping[connectorType]);
  }

  return {};
};

export const deleteConnectorById = ServiceHandler<unknown, unknown>({
  url: '/api/connector/v1/connections/:connectorId',
  method: 'DELETE',
});

export const addConnector = ServiceHandler({
  url: '/api/connector/v1/connections',
  method: 'POST',
  headers: { 'Content-Type': 'application/json' },
});

export interface WizerConnectorDetailsResponse {
  listTrainingMagicLink: string;
  addUserMagicLink: string;
  dashboardMagicLink: string;
}

export const getWizerConnectorDetails = ServiceHandler<
  unknown,
  WizerConnectorDetailsResponse
>({
  url: '/api/connector/v1/wizer/generateMagicLinks',
});
